'use strict';

export default class ButtonTooltip {
  constructor() {
        $(document).on('mouseenter focus', '.button-tooltip', function(){

            let $tooltip = $(this).siblings('.button-tooltip__content');

            if($tooltip.is(':visible'))
                return false;

            $tooltip.fadeIn();
        });
        $(document).on('mouseleave blur', '.button-tooltip', function(){

        	let $tooltip = $(this).siblings('.button-tooltip__content');

            $tooltip.fadeOut();
        });
  }
}